import axios from "axios";
import {
  getCurrentLanguage,
  getCurrentUser,
  delCurrentUser,
  delCurrentUserInfo,
} from "./Utils";
import { baseURL } from "../constants/defaultValues";
import { NotificationManager } from "../components/common/react-notifications";

// import AdTrace from 'react-adtrace';
import Adtrace from "web-adtrace"

export const SetAuthorizationAction = () => {
  delCurrentUserInfo();
  delCurrentUser();

  const shopVisited = sessionStorage.getItem("shopVisited");
  let url = window.location.href;

  // if (!shopVisited && (!url.includes('/s/s/') && !url.includes('/s/p/') && !url.includes('/s/c/'))) {
  window.location.href = "/user/phone";
  // }
  console.log(url);
  if ( (url.includes('/s/s/') || url.includes('/s/p/') || url.includes('/s/c/'))) {
    window.localStorage.setItem("deepLink", url);
  window.location.href = `/user/phone?url=${url}`;
  }
};


const faildRequest = (error, faild) => {
  let errorDesc = "Error: Network Error";
  if (error.response) {
    if (error.response.status === 401) {
      const shopVisited = sessionStorage.getItem("shopVisited");
      let url = window.location.href;
      if (
        !shopVisited &&
        !url.includes("/s/s/") &&
        !url.includes("/s/p/") &&
        !url.includes("/s/c/")
      ) {
        SetAuthorizationAction();
      }
    }

    if (error.response.data.Error !== undefined)
      errorDesc = error.response.data.Error;
    else if (error.response.data.description !== undefined)
      errorDesc = error.response.data.description;

    NotificationManager.error(errorDesc, "Error", 3000, null, null, "");
    const shopVisited = sessionStorage.getItem("shopVisited");
    let url = window.location.href;

    if (
      !shopVisited &&
      !url.includes("/s/s/") &&
      !url.includes("/s/p/") &&
      !url.includes("/s/c/")
    ) {
      faild(error.response);
    }
  } else {
    NotificationManager.error(
      "Error: Network Error",
      "Error",
      3000,
      null,
      null,
      ""
    );
    if (faild) {
      faild(errorDesc);
    }
  }
};

export const headers = () => {
  const curLang = getCurrentLanguage();
  const server = window.location.hostname;
  let host = null;
  switch (server) {
    case "app.7030.ir":
      host = "main";
      break;
    case "app.7030x.ir":
      host = "beta";
      break;
    case "pwa.70si.ir":
      host = "dev";
      break;
    case "localhost":
      host = "local";
      break;
  }
  const header = {
    "Content-Type": "application/json",
    "Custom-user-agent": `pwa-309-3.2.0-${host}`,
    API_SHARED_KEY:
      "lEy45wstZvZZ0sFIk1yy9gV0dahTrdAljCY8DE9hlaCwPzydRtrfQLQEyWfnFwDo",
    lang: curLang,
  };

  const curUser = getCurrentUser();
  if (curUser) {
    header.Authorization = `${curUser.token_type} ${curUser.access_token}`;
  }
  return header;
};

export const get = (url, param, callback, faild) => {
  async function fetchData() {
    axios
      .get(`${baseURL}${url}`, {
        params: param,
        headers: headers(),
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        callback(data);
      })
      .catch(function (error) {
        faildRequest(error, faild);
      });
  }
  fetchData();
};

export const getPDF = (url, param, callback, faild) => {
  fetch(url,
    {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      params: param,
      headers: headers()
    }
  )
    .then((response) => response.blob())
    .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
      var _url = window.URL.createObjectURL(blob);
      window.open(_url, "_blank").focus(); // window.open + focus
    }).catch((err) => {
      console.log(err);
    });
};

export const post = (url, param, callback, faild) => {
  async function fetchData() {
    axios
      .post(`${baseURL}${url}`, param, {
        headers: headers(),
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        callback(data);
      })
      .catch(function (error) {
        faildRequest(error, faild);
      });
  }
  fetchData();
};

export const put = (url, param, callback, faild) => {
  async function fetchData() {
    axios
      .put(`${baseURL}${url}`, param, {
        headers: headers(),
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        callback(data);
      })
      .catch(function (error) {
        faildRequest(error, faild);
      });
  }
  fetchData();
};

export const patch = (url, param, callback, faild) => {
  async function fetchData() {
    axios
      .patch(`${baseURL}${url}`, param, {
        headers: headers(),
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        callback(data);
      })
      .catch(function (error) {
        faildRequest(error, faild);
      });
  }
  fetchData();
};

export const delRequest = (url, param, callback, faild) => {
  async function fetchData() {
    axios
      .delete(`${baseURL}${url}`, {
        headers: headers(),
        data: param,
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        callback(data);
      })
      .catch(function (error) {
        faildRequest(error, faild);
      });
  }
  fetchData();
};

export const uploadFile = (url, param, uploadProgress, callback, faild) => {
  async function fetchData() {
    axios
      .post(`${baseURL}${url}`, param, {
        headers: headers(),
        onUploadProgress: (progressEvent) =>
          uploadProgress((progressEvent.loaded / progressEvent.total) * 100),
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        callback(data);
      })
      .catch(function (error) {
        faildRequest(error, faild);
      });
  }
  fetchData();
};

export const putUploadFile = (url, param, uploadProgress, callback, faild) => {
  async function fetchData() {
    axios
      .put(`${baseURL}${url}`, param, {
        headers: headers(),
        onUploadProgress: (progressEvent) =>
          uploadProgress((progressEvent.loaded / progressEvent.total) * 100),
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        callback(data);
      })
      .catch(function (error) {
        faildRequest(error, faild);
      });
  }
  fetchData();
};

export const getMarkup = (key, callback, faild) => {
  async function fetchData() {
    axios
      .get(`${baseURL}/services/markup/${key}`, {
        headers: headers(),
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        callback(data);
      })
      .catch(function (error) {
        faildRequest(error, faild);
      });
  }
  fetchData();
};

export const onShare = async (title, url, text) => {

  try {
    await navigator.share({
      title,
      url,
      text,
    });
  } catch (err) {
    console.log(`Couldn't share ${err}`);
  }
}

export const onShareWithFile = async (title, url, text) => {

  try {
    const file = new File([url], 'fileName.png', { type: url.type });
    const data = {
      url: text,
      title: title,
      text: title,
      files: [file]
    }
    await navigator.share(data);
  } catch (err) {
    console.log(`Couldn't share ${err}`);
  }
}

export var adtrace =
// new AdTrace(
{
  // app_token: "dhs63umqdg7d", //.com
  // app_token: "e1jemer8h7x2", //.ir

  appToken: "2rzxn206lbwy", //.android
  environment: "production", //"sandbox", // or 'sandbox' in case you are testing SDK locally with your web app

  // unique_id: localStorage.getItem('adTraceUID'), // each web app user needs to have unique identifier
}
// );

export const adtraceEvent = (eventConfig) => {

  // adtrace.trackEvent(eventConfig, (result) => {
  // }, (errorMsg, error) => {
  //   console.log(errorMsg, error);
  // });

  Adtrace.trackEvent(eventConfig)

}
